import CouponActionTypes from 'redux/coupon/types';

const initialState = {
  coupons: {
    data: null,
  },
  singleCoupon: {},
  filterOn: false,
  loading: false,
  error: null,
  saving: false,
  isExpotingData: false,
};

function couponsReducer(state = initialState, { type, payload }) {
  switch (type) {
    case CouponActionTypes.SET_ANY_DATA:
      return {
        ...state,
        ...payload,
      };

    case CouponActionTypes.START_CREATE_COUPON:
      return {
        ...state,
        saving: true,
      };
    case CouponActionTypes.CREATE_COUPON_SUCCESS:
      return {
        ...state,
        saving: false,
        coupons: { ...state.coupons, data: [payload, ...state.coupons.data] },
      };
    case CouponActionTypes.CREATE_COUPON_FAILURE:
      return {
        ...state,
        saving: false,
      };

    case CouponActionTypes.START_FETCH_COUPONS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CouponActionTypes.FETCH_COUPONS_SUCCESS:
      return {
        ...state,
        coupons: payload,
        loading: false,
        error: null,
      };
    case CouponActionTypes.FETCH_COUPONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case CouponActionTypes.FETCH_SINGLE_COUPON:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CouponActionTypes.FETCH_SINGLE_COUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        singleCoupon: payload,
      };
    case CouponActionTypes.FETCH_SINGLE_COUPON_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case CouponActionTypes.EXPORT_COUPON_START:
      return {
        ...state,
        isExpotingData: true,
      };
    case CouponActionTypes.EXPORT_COUPON_SUCCESS:
      return {
        ...state,
        isExpotingData: false,
      };
    case CouponActionTypes.EXPORT_COUPON_FAILURE:
      return {
        ...state,
        isExpotingData: false,
        error: payload,
      };
    default:
      return state;
  }
}

export default couponsReducer;
